export default __webpack_public_path__ + "static/media/jssa.d8371f71.png";